/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import { Typography } from "@material-ui/core";
import React, { Suspense } from "react";

const PlanList = React.lazy(async () => await import("./List.jsx"));

export const planRoute = {
  path: "/plans",
  key: "plans",
  component: () => (
    <Suspense fallback={<Typography variant="body1">Loading...</Typography>}>
      <PlanList />
    </Suspense>
  ),
};
